import React, { useEffect, useState } from 'react';
import { Grid } from 'antd';
import { LinkOutlined } from '@ant-design/icons';

const { useBreakpoint } = Grid;

const PlayerPage = ({ item }: { item: string }) => {
  const [type, setType] = useState<'clip' | 'video'>('video');
  const [embedUrl, setEmbedUrl] = useState<string | undefined>(undefined);
  const [clipId, setClipId] = useState<string | undefined>(undefined);
  const screens = useBreakpoint();
  const iframeSize = { width: 560, height: 315 };

  useEffect(() => {
    if (!item) return;

    const youtubeClipRegex = /^https?:\/\/(www\.)?youtube\.com\/clip\/([a-zA-Z0-9_-]+)/;
    const match = item.match(youtubeClipRegex);

    if (match) {
      setType('clip');
      setClipId(match[2]); // Unique clip ID
    } else {
      setType('video');
      setEmbedUrl(`https://www.youtube.com/embed/${item}`);
    }
  }, [item]);

  const containerStyle = {
    width: '100%',
    maxWidth: screens.xl ? `${iframeSize.width}px` : '100%',
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'center',
    aspectRatio: '16/9' as const,
    borderRadius: '8px',
    overflow: 'hidden',
    backgroundColor: '#000',
    color: '#fff',
    textAlign: 'center' as const,
  };

  return (
    <div style={containerStyle}>
      {type === 'video' && embedUrl ? (
        <iframe
          width="100%"
          height="100%"
          src={embedUrl}
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
          style={{ border: 0 }}
        />
      ) : type === 'clip' && clipId ? (
        <a
          href={item}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '1.5rem',
            fontWeight: 'bold',
            color: '#fff',
          }}
        >
          {clipId}
        </a>
      ) : (
        <div
          style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column' as const,
            justifyContent: 'center',
            alignItems: 'center',
            padding: '24px',
            border: '1px dashed #d9d9d9',
          }}
        >
          <LinkOutlined style={{ fontSize: '48px', color: '#999', marginBottom: '16px' }} />
          <p style={{ color: '#666', marginBottom: '8px' }}>The video player is unavailable.</p>
          <a href={item} target="_blank" rel="noopener noreferrer" style={{ color: '#1890ff', fontWeight: 'bold' }}>
            Click here to view on YouTube
          </a>
        </div>
      )}
    </div>
  );
};

export default PlayerPage;
